export interface CustomMode {
    description: string;
    instructions: string;
    preferredModel: string;
}

export interface CustomModesSectionProps {
    customModes: Record<string, CustomMode>;
    onCustomModesChange: (newModes: Record<string, CustomMode>) => void;
}

// Character limits
export const MAX_NAME_LENGTH = 20;
export const MAX_DESCRIPTION_LENGTH = 50;
export const MAX_INSTRUCTIONS_LENGTH = 10000;